export default __webpack_public_path__ + "static/media/step1.eac7e79f.png";